import React, { useEffect, useState } from 'react';

import { Skeleton } from '@material-ui/lab';
import {
  useUserClassroomMoves,
  userClassroomMovesGenerate,
  userClassroomMovesWarmup
} from 'sdk';

import { ReactComponent as FocusIcon } from 'pages/Teachers/Home/assets/focus-icon.svg';
import { ReactComponent as RevisitIcon } from 'pages/Teachers/Home/assets/revisit-icon.svg';
import StartEmptyBox from 'pages/Teachers/Home/components/StartEmptyBox';

import styles from './styles.module.scss';

const TomorrowsFocus = () => {
  // const [isFailed, setIsFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    data: userClassroomMovesData,
    isLoading: isUserClassroomMovesLoading
  } = useUserClassroomMoves();

  const fetchFocusData = async () => {
    setIsLoading(true);
    // setIsFailed(false);

    try {
      await userClassroomMovesGenerate();
      setIsLoading(false);
    } catch (error) {
      // setIsFailed(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFocusData();
  }, []);

  useEffect(() => {
    userClassroomMovesWarmup();
  }, []);

  return (
    <div className={styles.focusWidget}>
      {(isLoading || isUserClassroomMovesLoading) && (
        <div className={styles.loadingState}>
          <Skeleton variant="rect" width="100%" height={180} />
        </div>
      )}
      {!isLoading &&
        !isUserClassroomMovesLoading &&
        userClassroomMovesData?.suggested_moves.length > 0 && (
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <RevisitIcon className={styles.warningIcon} />
              <span className={styles.headerTitle}>Revisit</span>
            </div>

            <ul className={styles.bulletList}>
              {userClassroomMovesData?.suggested_moves.map((bullet, index) => (
                <li key={index} className={styles.bulletItem}>
                  {bullet}
                </li>
              ))}
            </ul>
          </div>
        )}
      {!isLoading &&
        !isUserClassroomMovesLoading &&
        userClassroomMovesData.length === 0 && (
          <StartEmptyBox
            stepNumber="STEP 2"
            description="Reflect on today's data and set goals for your next lesson."
            icon={<FocusIcon />}
          />
        )}
    </div>
  );
};

export default TomorrowsFocus;
